import { __decorate } from "tslib";
import { AutoEncoder, field } from '@simonbackx/simple-encoding';
import { OpenIDClientConfiguration } from './OpenID.js';
export class PlatformServerConfig extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.ssoConfiguration = null;
        this.googleConfiguration = null;
    }
}
__decorate([
    field({ decoder: OpenIDClientConfiguration, nullable: true, version: 360 })
], PlatformServerConfig.prototype, "ssoConfiguration", void 0);
__decorate([
    field({ decoder: OpenIDClientConfiguration, nullable: true, version: 360 })
], PlatformServerConfig.prototype, "googleConfiguration", void 0);
//# sourceMappingURL=PlatformServerConfig.js.map